import React from 'react';
import { useFormik } from 'formik';
import yup from '../../../common/utils/yup';
import { TextField, Text, Button } from 'porosys-ui';
import { useHistory, useLocation } from 'react-router-dom';
import { logUserIn } from '../api';
import '../styles.scss';

const validationSchema = yup.object({
    password: yup.string().required(),
    email: yup.string().required(),
});

const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
};

const LoginForm = ({ initialSsoError = '' }) => {
    const history = useHistory();
    const queryParams = useQuery();

    const inputValues = {
        email: '',
        password: '',
    };

    const { handleSubmit, values, handleChange, touched, errors } = useFormik({
        initialValues: inputValues,
        onSubmit: async values => {
            await logUserIn(values).then(res => {
                if (res && res.replace('Bearer ', '') !== 'null') {
                    localStorage.setItem('token', res);
                    history.push(queryParams.get('redirect') ? queryParams.get('redirect') : '/');
                    window.location.reload();
                } else {
                    errors.password = 'اطلاعات وارد شده اشتباه است';
                    handleError('password');

                    errors.email = 'اطلاعات وارد شده اشتباه است';
                    handleError('email');
                }
            });
        },
        validationSchema,
    });

    const handleError = state => {
        if (touched[state] && errors[state]) return errors[state];
    };

    const ssoError = queryParams.get('ssoError') || initialSsoError;

    return (
        <div className="login-page">
            <form className="login-form" onSubmit={handleSubmit}>
                <Text classes={{ root: 'form-title' }} variant="h5">
                    ورود به سیستم
                </Text>
                {ssoError && (
                    <>
                        <br />
                        <Text classes={{ root: 'sso-error' }} variant="body2">
                            {ssoError}
                        </Text>
                    </>
                )}
                <br />
                <br />
                <TextField
                    classes={{ root: 'form-input' }}
                    value={values.email}
                    label={'نام'}
                    name="email"
                    placeholder="وارد کنید..."
                    onChange={handleChange('email')}
                    errorMessage={handleError('email')}
                />
                <TextField
                    classes={{ root: 'form-input' }}
                    value={values.password}
                    label={'رمز عبور'}
                    name="password"
                    placeholder="وارد کنید..."
                    onChange={handleChange('password')}
                    errorMessage={handleError('password')}
                    type="password"
                />
                <div className="form-btn">
                    <Button classes={{ root: 'login-btn' }} color="primary" type="submit">
                        ورود
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default LoginForm;
